"use strict";

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _this = this;

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var Procedure_1 = require("./Procedure");

var types_1 = require("../types");

var PolymathError_1 = require("../PolymathError");

var utils_1 = require("../utils");

var entities_1 = require("../entities");

var ApproveErc20_1 = require("./ApproveErc20");
/**
 * @hidden
 */


exports.createRefreshSecurityTokenFactoryResolver = function (factories, securityTokenId) {
  return function () {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", factories.securityTokenFactory.refresh(securityTokenId));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };
};
/**
 * @hidden
 */


exports.createRefreshTieredStoFactoryResolver = function (factories, tieredStoId) {
  return function () {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", factories.tieredStoFactory.refresh(tieredStoId));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
  };
};
/**
 * Procedure that invests in a Tiered STO
 */


var InvestInTieredSto =
/*#__PURE__*/
function (_Procedure_1$Procedur) {
  _inherits(InvestInTieredSto, _Procedure_1$Procedur);

  function InvestInTieredSto() {
    var _this2;

    _classCallCheck(this, InvestInTieredSto);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(InvestInTieredSto).apply(this, arguments));
    _this2.type = types_1.ProcedureType.InvestInTieredSto;
    return _this2;
  }
  /**
   * Invest the specified amount in the STO
   *
   * Note that this procedure will fail if:
   * - The Security Token doesn't exist
   * - The STO address is invalid
   * - The STO is either archived or hasn't been launched
   * - The STO hasn't started yet
   * - The STO is paused
   * - Trying to invest on behalf of someone else if the STO doesn't allow beneficial investments
   * - The STO doesn't support investments in the selected currency
   */


  _createClass(InvestInTieredSto, [{
    key: "prepareTransactions",
    value: function prepareTransactions() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var args, context, stoAddress, symbol, amount, currency, _args$minTokens, minTokens, beneficiary, contractWrappers, factories, securityTokenId, tieredStoId, stoModule, _ref, _ref2, sto, currentAddress, isFinalized, isPaused, startDate, beneficialInvestmentsAllowed, fundraiseCurrencies, resolvers, unsupportedCurrencyError, stableCoinAddress;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                args = this.args, context = this.context;
                stoAddress = args.stoAddress, symbol = args.symbol, amount = args.amount, currency = args.currency, _args$minTokens = args.minTokens, minTokens = _args$minTokens === void 0 ? new contract_wrappers_1.BigNumber(0) : _args$minTokens;
                beneficiary = args.beneficiary;
                contractWrappers = context.contractWrappers, factories = context.factories;
                /*
                 * Validation
                 */

                _context3.prev = 4;
                _context3.next = 7;
                return contractWrappers.tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 7:
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](4);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 12:
                if (utils_1.isValidAddress(stoAddress)) {
                  _context3.next = 14;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.InvalidAddress,
                  message: "Invalid STO address ".concat(stoAddress)
                });

              case 14:
                securityTokenId = entities_1.SecurityToken.generateId({
                  symbol: symbol
                });
                tieredStoId = entities_1.TieredSto.generateId({
                  securityTokenId: securityTokenId,
                  stoType: types_1.StoType.Tiered,
                  address: stoAddress
                });
                _context3.next = 18;
                return contractWrappers.moduleFactory.getModuleInstance({
                  name: contract_wrappers_1.ModuleName.UsdTieredSTO,
                  address: stoAddress
                });

              case 18:
                stoModule = _context3.sent;

                if (stoModule) {
                  _context3.next = 21;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "STO ".concat(stoAddress, " is either archived or hasn't been launched")
                });

              case 21:
                _context3.next = 23;
                return Promise.all([factories.tieredStoFactory.fetch(tieredStoId), context.currentWallet.address()]);

              case 23:
                _ref = _context3.sent;
                _ref2 = _slicedToArray(_ref, 2);
                sto = _ref2[0];
                currentAddress = _ref2[1];
                isFinalized = sto.isFinalized, isPaused = sto.isPaused, startDate = sto.startDate, beneficialInvestmentsAllowed = sto.beneficialInvestmentsAllowed, fundraiseCurrencies = sto.fundraiseCurrencies;

                if (!(startDate > new Date())) {
                  _context3.next = 30;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "Cannot invest in STO ".concat(stoAddress, " because it hasn't started yet")
                });

              case 30:
                if (!isFinalized) {
                  _context3.next = 32;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "STO ".concat(stoAddress, " has already been finalized")
                });

              case 32:
                if (!isPaused) {
                  _context3.next = 34;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "STO ".concat(stoAddress, " is paused")
                });

              case 34:
                if (!(beneficiary && beneficiary !== currentAddress && !beneficialInvestmentsAllowed)) {
                  _context3.next = 36;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "Cannot invest on behalf of ".concat(beneficiary, " because this STO doesn't allow beneficial investments")
                });

              case 36:
                beneficiary = beneficiary || currentAddress;
                resolvers = [exports.createRefreshTieredStoFactoryResolver(factories, tieredStoId), exports.createRefreshSecurityTokenFactoryResolver(factories, securityTokenId)];
                unsupportedCurrencyError = new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "STO ".concat(stoAddress, " doesn't support investments in the selected currency")
                });

                if (!types_1.isInvestWithStableCoinArgs(args)) {
                  _context3.next = 49;
                  break;
                }

                stableCoinAddress = args.stableCoinAddress;

                if (fundraiseCurrencies.includes(contract_wrappers_1.FundRaiseType.StableCoin)) {
                  _context3.next = 43;
                  break;
                }

                throw unsupportedCurrencyError;

              case 43:
                _context3.next = 45;
                return this.addProcedure(ApproveErc20_1.ApproveErc20)({
                  tokenAddress: stableCoinAddress,
                  amount: amount,
                  spender: stoAddress
                });

              case 45:
                _context3.next = 47;
                return this.addTransaction(stoModule.buyWithUSDRateLimited, {
                  tag: types_1.PolyTransactionTag.BuyWithScRateLimited,
                  resolvers: resolvers
                })({
                  minTokens: minTokens,
                  beneficiary: beneficiary,
                  usdToken: stableCoinAddress,
                  investedSC: amount
                });

              case 47:
                _context3.next = 62;
                break;

              case 49:
                if (!(currency === types_1.Currency.POLY)) {
                  _context3.next = 58;
                  break;
                }

                if (fundraiseCurrencies.includes(contract_wrappers_1.FundRaiseType.POLY)) {
                  _context3.next = 52;
                  break;
                }

                throw unsupportedCurrencyError;

              case 52:
                _context3.next = 54;
                return this.addProcedure(ApproveErc20_1.ApproveErc20)({
                  amount: amount,
                  spender: stoAddress
                });

              case 54:
                _context3.next = 56;
                return this.addTransaction(stoModule.buyWithPOLYRateLimited, {
                  tag: types_1.PolyTransactionTag.BuyWithPolyRateLimited,
                  resolvers: resolvers
                })({
                  minTokens: minTokens,
                  beneficiary: beneficiary,
                  investedPOLY: amount
                });

              case 56:
                _context3.next = 62;
                break;

              case 58:
                if (fundraiseCurrencies.includes(contract_wrappers_1.FundRaiseType.ETH)) {
                  _context3.next = 60;
                  break;
                }

                throw unsupportedCurrencyError;

              case 60:
                _context3.next = 62;
                return this.addTransaction(stoModule.buyWithETHRateLimited, {
                  tag: types_1.PolyTransactionTag.BuyWithEthRateLimited,
                  resolvers: resolvers
                })({
                  minTokens: minTokens,
                  beneficiary: beneficiary,
                  value: amount
                });

              case 62:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[4, 9]]);
      }));
    }
  }]);

  return InvestInTieredSto;
}(Procedure_1.Procedure);

exports.InvestInTieredSto = InvestInTieredSto;